"use client";
import { loadStripe } from "@stripe/stripe-js/pure";
import { useEffect, useState } from "react";

import type { Stripe } from "@stripe/stripe-js";

let stripePromise: Promise<Stripe | null> | null = null;

function getStripePromise() {
	stripePromise ??= loadStripe(
		process.env.NODE_ENV === "development"
			? "pk_test_51TAp19C9m7Inb4qhndmanNQQ0132dPMiv00lvH5qSLFUEGTF9ZCnmKbZNxth4zZzzv6Ewk0xSGQ8dpnh12TsSG7z00ijtRKwRW"
			: "pk_live_51TAp0QFyqOadSG6RrshQnkUp5I1l9mtdw0J82OsMPW3l9I50BzNbu3kQ9kIvSJFqHtAEgDP8Yk0PIR5RQH2hLHdt00gJjr7en4",
	);
	return stripePromise;
}

export function useStripe() {
	const [stripe, setStripe] = useState<Stripe | null>(null);
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState<Error | null>(null);

	useEffect(() => {
		getStripePromise()
			.then((stripeInstance) => {
				setStripe(stripeInstance);
				setIsLoading(false);
			})
			.catch((err) => {
				setError(err);
				setIsLoading(false);
			});
	}, []);

	return { stripe, isLoading, error };
}

export function loadStripeNow() {
	return getStripePromise();
}
